export default __webpack_public_path__ + "static/media/aakashlogo-white.6c675d27.png";